import {
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  VOID7hggqo3abtya as VOID,
  indexOfwa4w6635jewi as indexOf,
  ArrayList3it5z8td81qkl as ArrayList,
  split2bvyvnrlcifjv as split,
  Unit_instanceat14thlj150z as Unit_instance,
  joinToString1cxrrlmo0chqs as joinToString,
  startsWith26w8qjqapeeq6 as startsWith,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  trim6jpmwojjgb3l as trim,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  lastIndexOfpmd3ei5son2n as lastIndexOf,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
  Enum3alwj03lh1n41 as Enum,
  Long2qws0ah9gnpki as Long,
  toString30pk9tzaqopn as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  toLongw1zpgk99d84b as toLong,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  toString1pkumu07cwy4m as toString_0,
  boxApply1qmzdb3dh90hg as boxApply,
  toString14fd7g605f91p as toString_1,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__toString_impl_cnueje2ackcuvowzg0n as DateTime__toString_impl_cnueje,
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  asyncz02dsa2nb2zt as async,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  openSync2m3qn99fqytu0 as openSync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName } from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_2,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import { Companion_getInstance1vfndg47rf0 as Companion_getInstance_0 } from './korlibs-io-fs-root-korlibs-io-fs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class FinalVfsFile {
  static g21(file) {
    var $this = createThis(this);
    $this.f21_1 = file;
    return $this;
  }
  static h21(vfs, path) {
    return this.g21(vfs.bi(path));
  }
  i21() {
    return this.f21_1.l21_1;
  }
  o21() {
    return this.f21_1.m21_1;
  }
  toString() {
    return 'FinalVfsFile(file=' + this.f21_1.toString() + ')';
  }
  hashCode() {
    return this.f21_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.f21_1.equals(tmp0_other_with_cast.f21_1))
      return false;
    return true;
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.r21_1 = pathInfo;
  }
  q21() {
    return this.r21_1;
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    super(name, ordinal);
    this.u21_1 = cmode;
    this.v21_1 = write;
    this.w21_1 = createIfNotExists;
    this.x21_1 = truncate;
    this.y21_1 = read;
    this.z21_1 = append;
    this.a22_1 = createNew;
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().j1u_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.b22_1 = file;
    this.c22_1 = exists;
    this.d22_1 = isDirectory;
    this.e22_1 = size;
    this.f22_1 = device;
    this.g22_1 = inode;
    this.h22_1 = mode;
    this.i22_1 = owner;
    this.j22_1 = group;
    this.k22_1 = createTime;
    this.l22_1 = modifiedTime;
    this.m22_1 = lastAccessTime;
    this.n22_1 = extraInfo;
    this.o22_1 = kind;
    this.p22_1 = id;
    this.q22_1 = exception;
  }
  q21() {
    return this.b22_1.q21();
  }
  r22(showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.w(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile)
      this_0.h('file=' + this.b22_1.toString());
    else
      this_0.h('file=' + this.b22_1.s22());
    this_0.h('exists=' + this.c22_1);
    this_0.h('isDirectory=' + this.d22_1);
    this_0.h('size=' + this.e22_1.toString());
    this_0.h('device=' + this.f22_1.toString());
    this_0.h('inode=' + this.g22_1.toString());
    this_0.h('mode=' + this.h22_1);
    this_0.h('owner=' + this.i22_1);
    this_0.h('group=' + this.j22_1);
    this_0.h('createTime=' + DateTime__toString_impl_cnueje(this.k22_1));
    this_0.h('modifiedTime=' + DateTime__toString_impl_cnueje(this.l22_1));
    this_0.h('lastAccessTime=' + DateTime__toString_impl_cnueje(this.m22_1));
    this_0.h('extraInfo=' + toString(this.n22_1));
    if (!(this.o22_1 == null)) {
      this_0.h('kind=' + toString(this.o22_1));
    }
    this_0.h('id=' + this.p22_1);
    return 'VfsStat(' + joinToString(this_0, ', ') + ')';
  }
  toString() {
    return this.r22(true);
  }
  t22(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  }
  u22(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.b22_1 : file;
    exists = exists === VOID ? this.c22_1 : exists;
    isDirectory = isDirectory === VOID ? this.d22_1 : isDirectory;
    size = size === VOID ? this.e22_1 : size;
    device = device === VOID ? this.f22_1 : device;
    inode = inode === VOID ? this.g22_1 : inode;
    mode = mode === VOID ? this.h22_1 : mode;
    owner = owner === VOID ? this.i22_1 : owner;
    group = group === VOID ? this.j22_1 : group;
    createTime = createTime === VOID ? this.k22_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.l22_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.m22_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.n22_1 : extraInfo;
    kind = kind === VOID ? this.o22_1 : kind;
    id = id === VOID ? this.p22_1 : id;
    exception = exception === VOID ? this.q22_1 : exception;
    return $super === VOID ? this.t22(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.t22.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  }
  hashCode() {
    var result = this.b22_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.c22_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d22_1) | 0;
    result = imul(result, 31) + this.e22_1.hashCode() | 0;
    result = imul(result, 31) + this.f22_1.hashCode() | 0;
    result = imul(result, 31) + this.g22_1.hashCode() | 0;
    result = imul(result, 31) + this.h22_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.i22_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j22_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.k22_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.l22_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.m22_1) | 0;
    result = imul(result, 31) + (this.n22_1 == null ? 0 : hashCode(this.n22_1)) | 0;
    result = imul(result, 31) + (this.o22_1 == null ? 0 : hashCode(this.o22_1)) | 0;
    result = imul(result, 31) + (this.p22_1 == null ? 0 : getStringHashCode(this.p22_1)) | 0;
    result = imul(result, 31) + (this.q22_1 == null ? 0 : hashCode(this.q22_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.b22_1.equals(tmp0_other_with_cast.b22_1))
      return false;
    if (!(this.c22_1 === tmp0_other_with_cast.c22_1))
      return false;
    if (!(this.d22_1 === tmp0_other_with_cast.d22_1))
      return false;
    if (!this.e22_1.equals(tmp0_other_with_cast.e22_1))
      return false;
    if (!this.f22_1.equals(tmp0_other_with_cast.f22_1))
      return false;
    if (!this.g22_1.equals(tmp0_other_with_cast.g22_1))
      return false;
    if (!(this.h22_1 === tmp0_other_with_cast.h22_1))
      return false;
    if (!(this.i22_1 === tmp0_other_with_cast.i22_1))
      return false;
    if (!(this.j22_1 === tmp0_other_with_cast.j22_1))
      return false;
    if (!equals(this.k22_1, tmp0_other_with_cast.k22_1))
      return false;
    if (!equals(this.l22_1, tmp0_other_with_cast.l22_1))
      return false;
    if (!equals(this.m22_1, tmp0_other_with_cast.m22_1))
      return false;
    if (!equals(this.n22_1, tmp0_other_with_cast.n22_1))
      return false;
    if (!equals(this.o22_1, tmp0_other_with_cast.o22_1))
      return false;
    if (!(this.p22_1 == tmp0_other_with_cast.p22_1))
      return false;
    if (!equals(this.q22_1, tmp0_other_with_cast.q22_1))
      return false;
    return true;
  }
}
class Companion {}
class VfsCachedStatContext {
  constructor(stat) {
    this.v22_1 = stat;
  }
  q1() {
    return Companion_instance;
  }
}
class Vfs$Proxy$initOnce$slambda {
  constructor(this$0) {
    this.w22_1 = this$0;
  }
  w1n($this$async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
  }
  qd(p1, $completion) {
    return this.w1n((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Vfs {
  constructor($box) {
    boxApply(this, $box);
  }
  s22() {
    return '';
  }
  i23(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.s22()), get_pathInfo(path)));
  }
  j23() {
    return new VfsFile(this, '');
  }
  bi(path) {
    return this.j23().bi(path);
  }
  e23(path) {
    return this.j23().bi(path);
  }
  i1p($completion) {
    return Unit_instance;
  }
  k23(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.e23(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      this_0.b22_1.n21_1 = this_0;
    return this_0;
  }
  l23(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().j1u_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance().j1u_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.k23(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.k23.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  m23(path, extraInfo, cache, exception) {
    return new VfsStat(this.e23(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance().j1u_1, Companion_getInstance().j1u_1, Companion_getInstance().j1u_1, extraInfo, VOID, VOID, exception);
  }
  n23(path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.m23(path, extraInfo, cache, exception) : $super.m23.call(this, path, extraInfo, cache, exception);
  }
  f23(path, mode, $completion) {
    unsupported(this);
  }
  g23(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t_0.bind(VOID, this, path, range), $completion);
  }
  h23(path, $completion) {
    return this.n23(path);
  }
  p21(path, $completion) {
    return FinalVfsFile.h21(this, path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.x22_1 = null;
  }
  p21(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getUnderlyingUnscapedFile__y1cdv2.bind(VOID, this, path), $completion);
  }
  y22($completion) {
  }
  z22($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_initOnce__uuyf07.bind(VOID, this), $completion);
  }
  f23(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea.bind(VOID, this, path, mode), $completion);
  }
  g23(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t.bind(VOID, this, path, range), $completion);
  }
  h23(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc.bind(VOID, this, path), $completion);
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.k21_1 = new Mixin();
    this.l21_1 = vfs;
    this.m21_1 = path;
    this.n21_1 = null;
  }
  vx(_set____db54di) {
    this.k21_1.vx(_set____db54di);
  }
  wx() {
    return this.k21_1.wx();
  }
  p23() {
    return new VfsFile(this.l21_1, get_folder_0(this));
  }
  j23() {
    return this.l21_1.j23();
  }
  s22() {
    return this.l21_1.i23(this.m21_1);
  }
  bi(path) {
    return new VfsFile(this.l21_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.m21_1), get_pathInfo(path))));
  }
  b23(mode, $completion) {
    return this.l21_1.f23(this.m21_1, mode, $completion);
  }
  c23(range, $completion) {
    return this.l21_1.g23(this.m21_1, range, $completion);
  }
  q23(range, $completion) {
    return this.l21_1.g23(this.m21_1, toLongRange(range), $completion);
  }
  r23($completion) {
    return this.l21_1.g23(this.m21_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  }
  o23($completion) {
    return this.r23($completion);
  }
  s23($completion) {
    return this.r23($completion);
  }
  t23(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun.bind(VOID, this, charset), $completion);
  }
  u23(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.t23(charset, $completion) : $super.t23.call(this, charset, $completion);
  }
  d23($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_0.bind(VOID, this), $completion);
  }
  v23() {
    return Companion_instance_0.w23(this);
  }
  toString() {
    return this.l21_1.toString() + '[' + this.m21_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.l21_1);
    result = imul(result, 31) + getStringHashCode(this.m21_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.l21_1, tmp0_other_with_cast.l21_1))
      return false;
    if (!(this.m21_1 === tmp0_other_with_cast.m21_1))
      return false;
    return true;
  }
}
class Companion_0 {
  w23(jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).j23();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    super();
    this.y23_1 = jailRoot;
    this.z23_1 = normalize(this.y23_1.q21());
  }
  a23(path, $completion) {
    return this.y23_1.bi(trim(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  s22() {
    return this.y23_1.s22();
  }
  toString() {
    return 'JailVfs(' + this.y23_1.toString() + ')';
  }
}
class Companion_1 {}
class LocalVfs extends Vfs {
  constructor(fs) {
    fs = fs === VOID ? Companion_getInstance_0() : fs;
    super();
    this.a24_1 = fs;
  }
  toString() {
    return 'LocalVfs';
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, failFromStatus) {
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.b24_1 = url;
    this.c24_1 = failFromStatus;
    this.d24_1 = this.b24_1;
  }
  s22() {
    return this.d24_1;
  }
  e24(path) {
    var result = trim(this.b24_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_1(_Char___init__impl__6a9atx(47)) + trim(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
}
//endregion
function getUnderlyingUnscapedFile(_this__u8e3s4, $completion) {
  return _this__u8e3s4.l21_1.p21(_this__u8e3s4.m21_1, $completion);
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function normalize(_this__u8e3s4, removeEndSlash) {
  removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var tmp_0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = path.substring(schemeIndex);
    if (startsWith(tmp$ret$1, '://')) {
      tmp_0 = 3;
    } else {
      tmp_0 = 1;
    }
    var take = tmp_0;
    // Inline function 'kotlin.text.substring' call
    var endIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = path.substring(0, endIndex);
    // Inline function 'kotlin.text.substring' call
    var startIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = path.substring(startIndex);
    tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5), removeEndSlash);
  } else {
    var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.h1();
    var path2PathLength;
    // Inline function 'korlibs.io.file.fastForEachWithIndex' call
    // Inline function 'kotlin.also' call
    var this_0 = split(path2, ['/']);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.normalize.<anonymous>' call
    path2PathLength = this_0.e1();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      var index = n;
      var part = this_0.d1(n);
      switch (part) {
        case '':
          if (out.g1() || !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '.':
          if (index === (path2PathLength - 1 | 0) && !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '..':
          var tmp_2;
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.g1()) {
            tmp_2 = !(index === 1);
          } else {
            tmp_2 = false;
          }

          if (tmp_2) {
            out.l3(out.e1() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.h(part);
          break;
      }
      n = n + 1 | 0;
    }
    tmp = joinToString(out, '/');
  }
  return tmp;
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function get_baseName(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_baseName_0(_this__u8e3s4) {
  return get_baseName(_this__u8e3s4.q21());
}
function get_folder(_this__u8e3s4) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  var endIndex = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(0, endIndex);
}
function get_folder_0(_this__u8e3s4) {
  return get_folder(_this__u8e3s4.q21());
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex(_this__u8e3s4) : startIndex;
  // Inline function 'kotlin.takeIf' call
  var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.io.file.lastIndexOfOrNull.<anonymous>' call
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_instance;
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  try {
    var tmp = $this.w22_1.y22($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_getUnderlyingUnscapedFile__y1cdv2($this, path, $completion) {
  var tmp = $this.z22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.a23(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = getUnderlyingUnscapedFile(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_initOnce__uuyf07($this, $completion) {
  if ($this.x22_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.mc();
    var tmp_0 = CoroutineScope(tmp$ret$0.an(SupervisorJob()).an(CoroutineName.n1b('Initializing.' + $this.toString())));
    tmp.x22_1 = async(tmp_0, VOID, VOID, Vfs$Proxy$initOnce$slambda_0($this));
  }
  var tmp_1 = ensureNotNull($this.x22_1).k17($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return $this;
}
function *_generator_open__qjxcea($this, path, mode, $completion) {
  var tmp = $this.z22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.a23(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.b23(mode, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_readRange__lxd64t($this, path, range, $completion) {
  var tmp = $this.z22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.a23(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.c23(range, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_stat__qhnowc($this, path, $completion) {
  var tmp = $this.z22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.a23(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.d23($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1.u22($this.e23(path));
}
function Vfs$Proxy$initOnce$slambda_0(this$0) {
  var i = new Vfs$Proxy$initOnce$slambda(this$0);
  var l = function ($this$async, $completion) {
    return i.w1n($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_readRange__lxd64t_0($this, path, range, $completion) {
  // Inline function 'korlibs.io.async.useIt' call
  var tmp = $this.f23(path, VfsOpenMode_READ_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.readRange.<anonymous>' call
    this_0.l1r_1 = range.f2();
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.Long.minus' call
    var a = (new Long(2147483647, 0)).x1(toLong(1));
    var b = range.e2().x1(range.f2());
    var tmp$ret$1 = a.w1(b) <= 0 ? a : b;
    var tmp_1 = readBytesUpTo(this_0, tmp$ret$1.i2() + 1 | 0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.i1p($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function unsupported($this) {
  throw UnsupportedOperationException.aa('unsupported for ' + toString_0(getKClassFromExpression($this)) + ' : ' + $this.toString());
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_VfsFile_kt__9wj0sz();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
function *_generator_readString__6uahun($this, charset, $completion) {
  var tmp = $this.o23($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_2(tmp, charset);
}
function *_generator_stat__qhnowc_0($this, $completion) {
  var tmp0_elvis_lhs = $this.n21_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = $this.l21_1.h23($this.m21_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function *_generator_readAsSyncStream__xvjwgr(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.o23($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return openSync(tmp);
}
function readAsSyncStream(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAsSyncStream__xvjwgr.bind(VOID, _this__u8e3s4), $completion);
}
function toLongRange(_this__u8e3s4) {
  _init_properties_VfsFile_kt__9wj0sz();
  return toLong(_this__u8e3s4.f2()).z1(toLong(_this__u8e3s4.e2()));
}
var properties_initialized_VfsFile_kt_lqx1ld;
function _init_properties_VfsFile_kt__9wj0sz() {
  if (!properties_initialized_VfsFile_kt_lqx1ld) {
    properties_initialized_VfsFile_kt_lqx1ld = true;
    LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).z1(new Long(-1, 2147483647));
  }
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
//region block: post-declaration
initMetadataForClass(FinalVfsFile, 'FinalVfsFile');
initMetadataForClass(VfsNamed, 'VfsNamed');
initMetadataForClass(VfsOpenMode, 'VfsOpenMode');
initMetadataForClass(VfsStat, 'VfsStat');
initMetadataForCompanion(Companion);
protoOf(VfsCachedStatContext).zc = get;
protoOf(VfsCachedStatContext).zm = fold;
protoOf(VfsCachedStatContext).ym = minusKey;
protoOf(VfsCachedStatContext).an = plus;
initMetadataForClass(VfsCachedStatContext, 'VfsCachedStatContext', VOID, VOID, [Element]);
initMetadataForLambda(Vfs$Proxy$initOnce$slambda, VOID, VOID, [1]);
initMetadataForClass(Vfs, 'Vfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForClass(Proxy, 'Proxy', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForClass(VfsFile, 'VfsFile', VOID, VOID, VOID, [0, 2, 3, 1, 4, 5]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(JailVfs, 'JailVfs', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(LocalVfs, 'LocalVfs', VOID, VOID, VOID, [1, 4, 0, 2, 3]);
initMetadataForClass(UrlVfs, 'UrlVfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  VfsOpenMode_READ_getInstance as VfsOpenMode_READ_getInstance1f4z3vmo4033h,
  getUnderlyingUnscapedFile as getUnderlyingUnscapedFilej1r5tpfxb7a7,
  readAsSyncStream as readAsSyncStream2ficq0l6vek7d,
  _PathInfo___init__impl__vpw96a as _PathInfo___init__impl__vpw96aee5jvc40cw94,
  _PathInfo___get_fullPath__impl__21fx6x as _PathInfo___get_fullPath__impl__21fx6x1rfietgv3lnmb,
  Companion_instance as Companion_instance28oneptpyw0i3,
  LocalVfs as LocalVfs18bzski76hhpp,
  UrlVfs as UrlVfs292f1sja450ff,
  Proxy as Proxy2ri7nr2ijtx4g,
  VfsCachedStatContext as VfsCachedStatContext2gte5m09f8ox9,
  Vfs as Vfs3mgmizq3oi7gy,
  get_baseName as get_baseName7iz3sifr1imo,
  get_baseName_0 as get_baseName2yf63efofm8te,
  normalize as normalize34ppus0f5oo02,
  get_parent as get_parent1emraos91g459,
  get_pathInfo as get_pathInfo26tycr2r540oz,
};
//endregion
